import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Command from '../../action/command';
import CustomButton from '../../components/CustomButton';
import { issueReportsFetchStatusSelector } from '../../selector/issueReportsSelector';

/**
 * What a problem-report detail page shows when the report is not in the
 * loaded list. Three different situations, and a blank page used to stand for
 * all of them: still loading (nothing to say yet), the list failed to load,
 * or it loaded and the report is not in it — deleted, or a stale link.
 */
const IssueReportUnavailable = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const fetchStatus = useSelector(issueReportsFetchStatusSelector);

    if (fetchStatus !== 'loaded' && fetchStatus !== 'failed') return null;

    return (
        <div className={'bg-text-contrast rounded-[5px] shadow-sm p-6 flex flex-col items-start gap-4'} role={'alert'}>
            <p className={'text-sm text-foreground'}>
                {fetchStatus === 'failed'
                    ? t('issue_reports.details.load_failed')
                    : t('issue_reports.details.not_found')}
            </p>
            <CustomButton
                title={t('issue_reports.details.reload')}
                onClick={() => dispatch(Command.IssueReport.fetchIssueReports({ includeArchived: true }))}
                isFilled={false}
                fullWidth={false}
            />
        </div>
    );
};

export default IssueReportUnavailable;
